/**
 * Report Designer drop target
 */
export class ReportDesignerDropTarget {
  /**
   * Margin from the page's top border in px. Must be a multiple of the page's row height
   */
  top = 0;

  /**
   * Margin from the page's left border in px. Must be a multiple of the page's column width
   */
  left = 0;

  /**
   * Width px. Must be a multiple of the page's column width
   */
  width = 0;

  /**
   * Height in px. Must be a multiple of the page's row height
   */
  height = 0;

  /**
   * Distance W
   */
  distanceW = 0;

  /**
   * Distance H
   */
  distanceH = 0;

  /**
   * Width
   */
  sizeX = 0;

  /**
   * Height
   */
  sizeY = 0;

  /**
   * Min width
   */
  minSizeX = 0;

  /**
   * Min height
   */
  minSizeY = 0;

  /**
   * Minimum width
   */
  minWidth = 0;

  /**
   * Minimum hegight
   */
  minHeight = 0;

  /**
   * Last gridster column
   */
  lastGridsterCol = -1;

  /**
   * Last Gridster row
   */
  lastGridsterRow = -1;
}
